import React, { useState, useCallback, useEffect } from "react";

import Dashboard from "./pages/Dashboard";
import TicketDetail from "./pages/TicketDetail";
import { AnimatePresence } from "motion/react";
import {
  Box,
  Button,
  Divider as MuiDivider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import { spacing, useTheme } from "@mui/system";
import styled from "@emotion/styled";
import { LayoutDashboard, Settings as IconSettings } from "lucide-react";
import { useParams } from "react-router-dom";
import { ticketService } from "./services/ticketService";

const Divider = styled(MuiDivider)(spacing);

//Save button nella details della richiesta

export default function SupportHub() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleApi = async () => {
    try {
      const endpoint =
        "https://mobility-quote-pro-copy-b53933b4.base44.app/api/functions/calculateQuote";

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key":
            "23947a91d9a79e360ca67d02f211243e81b191c8ae183583b85e90672251553e",
        },
        body: JSON.stringify({
          provinceCode: "MI",
          vehicleValue: 25000,
          duration: 24,
        }),
      };
      const response = await fetch(endpoint, requestOptions);

      const responseData = await response.json();

      console.log(responseData);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box>
      <Helmet title="Support Hub" />
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "start",
          gap: 4,
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h3" display="inline">
          Support Hub
        </Typography>
      </Box>
      <Divider mt={4} />
      <Button onClick={handleApi} variant="contained">
        Test
      </Button>
      <Box
        sx={{
          display: "flex",

          fontFamily: "Inter, sans-serif",
        }}
      >
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            overflowX: "hidden",
          }}
        >
          <AnimatePresence mode="wait">
            <Dashboard key="dashboard" />
          </AnimatePresence>
        </Box>
      </Box>
    </Box>
  );
}
